import { render, staticRenderFns } from "./step-tech-transmission.vue?vue&type=template&id=0ccf699c"
import script from "./step-tech-transmission.vue?vue&type=script&lang=ts"
export * from "./step-tech-transmission.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports